<template>
    <div>
        <div class="row" v-if="$gate.isReception() || $gate.isAdmin() || $gate.isSupervisor()">
            <div class="col-md-7">
                <Item :products="productItem" :target="'vmbc_product'" :Settings='POSType' :options="options" :weeks="numberofweeks" @modals="showModal" @Add-Product="Add" @weeks-value="numberWeeks"></Item>
            </div>
            <div class="col-md-5">

                <div class="row">
                    <!-- <multi-select :options="customers"
                        :selected-options="customer"
                        placeholder="Select Parent"
                        @change="test">
                    </multi-select> -->

                    <div class="col-md-12">
                        <sub class="text-danger">2nd</sub>
<!--                        <basic-select :options="customers"-->
<!--                                    :selected-option="customer"-->
<!--                                    placeholder="Select Customer"-->
<!--                                    @select="onSelect">-->
<!--                        </basic-select>-->
                        <model-list-select :list="customerList"
                                           v-model="customer"
                                           option-value="value"
                                           option-text="text"
                                           placeholder="Select Customer"
                                           @searchchange="debouncedFetchCustomers"
                                           @select="onSelect">

                        </model-list-select>
                    </div>
                    <!-- <div class="col-md-12" v-if="customer.value !== ''">
                        <basic-select :options="customerStudentValue"
                                    :selected-option="student"
                                    placeholder="Select Student"
                                    @select="onSelect2">
                        </basic-select>
                    </div> -->

                    <Cart :tax_vat_one="tax_vat_one" :tax_vat="tax_vat" :carts="cartProduct" @add-qty="addQty" @sub-qty="subQty" @remove-cart="removecart" :students="customerStudentValue"/>

                    <Total :tax_vat_one="tax_vat_one" :tax_vat="tax_vat" :carts="cartProduct" :customer="customerDetails" :student="customerStudent" :settings="settings"/>
                </div>

            </div>
        </div>

        <div class="row" v-else>
            <notfound></notfound>
        </div>
    </div>
</template>

<script>
import Item from './Item.vue'
import Cart from './Cart.vue'
import Total from './Total.vue'
import { MultiSelect, ModelListSelect   } from 'vue-search-select'
import { BasicSelect } from 'vue-search-select'

import Swal from 'sweetalert2'
import {debounce} from "lodash";
    window.Swal = Swal
    const toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
    });
export default {
    // props: ['user'],
    components: {
        BasicSelect,
        MultiSelect,
        ModelListSelect,
        Item,
        Cart,
        Total
    },
    data() {
        return {
            user: this.$root.id,
            POSType: {
                Category: "Trial",
                IsProduct: 1,
                CartName: 'cartTrial',
                URL:  '/Sales-Trial'
            },
            customers: [],
            customerList: [],
            customerDetails:[],
            customerStudent:[],
            customerStudentValue:[],
            productItem:[],
            options:[],
            numberofweeks: 0,
            settings: [],
            cartProduct: [],
            cartaddProduct: {
                id: '',
                product: '',
                option: '',
                price: '',
                quantity: '',
                notes: '',
                discount: '',
                priceExcl: '',
                total: '',
                excl: '',
                vat: '',
                xero: '',
                discountpercent:'',
                datestart: '',
                dateend: '',
                weekid: '',
                student: '',
            },
            customer: {
                value: '',
                text: ''
                },
            student: {
                value: '',
                text: ''
                },
            walkin: []
        }
    },
    created() {
        this.getProducts();
        this.getSettings();
        //this.getCustomers();
        this.viewCartProduct();
        this.users();
        this.debouncedFetchCustomers = debounce(this.fetchCustomers, 600);
    },
    methods: {
        numberWeeks(value) {
            this.numberofweeks = value
        },
        users() {
            let parsed = JSON.stringify(this.user);
            localStorage.setItem('user', parsed);

            let POSType = JSON.stringify(this.POSType);
            localStorage.setItem('POSType', POSType);
        },
        onSelect(items){
            //this.customer = items

            if(this.customer.value === 3){
                const {value: formValues} = Swal.fire({
                title: 'Multiple inputs',
                html:
                    '<input id="swal-input1" class="swal2-input" placeholder="name">' +
                    '<input id="swal-input2" class="swal2-input" placeholder="email">' +
                    '<input id="swal-input3" class="swal2-input" placeholder="mobile">',
                focusConfirm: false,
                preConfirm: () => {

                    this.walkin.name = document.getElementById('swal-input1').value,
                    this.walkin.email = document.getElementById('swal-input2').value,
                    this.walkin.mobile = document.getElementById('swal-input3').value

                }
                })
            }
                this.student= {}
                this.walkin = {}

                axios
                .get('./api/POS/Customers/'+ this.customer.value)
                .then((result) => {
                    this.customerDetails = result.data.mother
                    this.customerStudentValue = result.data.childvalue

                    let customer = JSON.stringify(this.customerDetails);
                    localStorage.setItem('customer', customer);

                    console.log(result)
                }).catch((err) => {
                    console.log(err)
                });
        },
        onSelect2(items){
            this.student = items

            axios
            .get('./api/POS/Student/' + this.student.value)
            .then((result) => {
                this.customerStudent = result.data.child

                let student = JSON.stringify(this.customerStudent);
                localStorage.setItem('student', student);
            }).catch((err) => {
                console.log(err)
            });

        },
        getCustomers() {
            axios
            .get('./api/POS/Customers')
            .then((result) => {
                this.customers = result.data
            }).catch((err) => {
                console.log(err)
            });
        },
        fetchCustomers(searchQuery){
            if (searchQuery.length < 3) return;
            axios
                .get('./api/POS/Search/Customers/' + searchQuery)
                .then((result) => {
                    this.customerList = result.data
                }).catch((err) => {
                console.log(err)
            });

        },
        getProducts() {
            axios
            .get('./api/POS/Service')
            .then((result) => {
                this.productItem = result.data
            }).catch((err) => {
                console.log(err)
            });
        },
        showModal(e) {
            axios
            .get('./api/POS/Service/'+e)
            .then((result) => {
                this.numberofweeks = 1
                this.options = (result.data.services || []).map(option => {
                    option.quantity = 1
                    option.weeks = 1
                    return option
                })
            }).catch((err) => {
                console.log(err)
            });
        },
        Add(e){
            if(e.option_price > 0){
                    this.cartaddProduct.id = e.option_id
                    this.cartaddProduct.product = e.item_name
                    this.cartaddProduct.xero = e.item_xero

                    let disc = e.status == 'Adult' ? e.quantity : e.weeks

                    this.cartaddProduct.option = e.option_name + ' ' + e.week_name + ' ' + e.start + ' to ' + e.end
                    this.cartaddProduct.price = e.option_price
                    this.cartaddProduct.quantity = disc
                    this.cartaddProduct.notes = e.notes
                    this.cartaddProduct.priceExcl = parseFloat(e.option_price / this.tax_vat_one).toFixed(2)

                    let discount = 0
                    if(e.discountvalue == 'percent') {
                        discount = (disc * e.option_price) * (e.discount / 100)
                    }
                    if(e.discountvalue == 'fixed') {
                        discount = e.discount
                    }

                    let total = 0
                    let excl = 0
                    let vat = 0

                    total = (disc * e.option_price) - discount
                    excl = total / this.tax_vat_one
                    vat = excl * this.tax_vat

                    this.cartaddProduct.discount = parseFloat(discount).toFixed(2)
                    this.cartaddProduct.discountpercent = parseFloat((discount / (e.option_price * disc)) * 100).toFixed(2)
                    this.cartaddProduct.total = parseFloat(total).toFixed(2)
                    this.cartaddProduct.excl = parseFloat(excl).toFixed(2)
                    this.cartaddProduct.vat = parseFloat(vat).toFixed(2)
                    this.cartaddProduct.datestart = e.dateStart
                    this.cartaddProduct.dateend = e.dateEnd
                    this.cartaddProduct.weekid = e.weekid
                    this.cartProduct.student = null

                    this.cartProduct.push(this.cartaddProduct)
                    this.storeCartProduct()

                    this.options = {}

                    e.notes = ''
                    e.discount = '0'
                    e.discountvalue = ''
                    e.quantity = '1'
                    $('.modal').modal('hide');
                    toast({
                        type: 'success',
                        title: 'Product add to cart'
                        })
            } else{
                toast({
                type: 'warning',
                title: 'Please select price'
                })
            }
        },
        removecart(index) {
            this.cartProduct.splice(index, 1)
            this.storeCartProduct()
        },
        storeCartProduct(){
            let parsed = JSON.stringify(this.cartProduct)
            localStorage.setItem(this.POSType.CartName, parsed)
            this.viewCartProduct();
        },
        viewCartProduct() {
            if(localStorage.getItem(this.POSType.CartName)){
                this.cartProduct = JSON.parse(localStorage.getItem(this.POSType.CartName))
            }
        },
        getSettings() {
            axios
            .get('./api/Settings')
            .then((result) => {
                this.settings = result.data
                let settings = JSON.stringify(result.data)
                localStorage.setItem('Settings', settings)
            }).catch((err) => {
                console.log(err)
            });
        },
        addQty(item) {
             Object.assign(item, {
                quantity: parseInt(item.quantity) + 1,
                excl: parseFloat(((item.quantity + 1) * item.price) - item.discount) / this.tax_vat_one,
                vat: parseFloat((((item.quantity + 1) * item.price) - item.discount) / this.tax_vat_one) * this.tax_vat,
                total: parseFloat((item.quantity + 1) * item.price) - item.discount
            })

            localStorage.setItem(this.POSType.CartName, JSON.stringify(this.cartProduct))
        },
        subQty(item) {
             Object.assign(item, {
                quantity: parseInt(item.quantity) - 1,
                excl: parseFloat(((item.quantity - 1) * item.price) - item.discount) / this.tax_vat_one,
                vat: parseFloat((((item.quantity - 1) * item.price) - item.discount) / this.tax_vat_one) * this.tax_vat,
                total: parseFloat((item.quantity - 1) * item.price) - item.discount
            })

            localStorage.setItem(this.POSType.CartName, JSON.stringify(this.cartProduct))
        },

    },
    watch:{
        customer(){
            this.onSelect();
        }
    },
    computed: {
        tax_vat() {
            return this.settings.reduce((total, tax) => {
                return total + (tax.Tax / 100)
            }, 0)
        },
        tax_vat_one() {
            return this.tax_vat + 1
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/POS/Trial.vue